/**
* @author Edgar Escobedo
* @description Obtiene los creditos por paginas de documento
* @updatedDate 27-08-2024
* @param {Number} number 
* @returns {Array}
*/
const countCreditsByPages = (pages, credits, addPages) => {
    let afterPages = addPages
    let totalCredits = 0

    totalCredits = totalCredits + credits
    while (pages > afterPages) {
        totalCredits = totalCredits + credits
        afterPages += addPages
    }
    return totalCredits
}

/**
 * @author Pedro Antonio
 * @param {File} object
 * @param {string} property
 */
const getFileMediaType = (object, property) => {
    let mimeType = ""
    if (object[property]) {
        mimeType = object[property].toLowerCase()
        mimeType = mimeType.includes('pdf')
            ? 'pdf'
            : object[property].includes('video')
                ? 'video'
                : object[property].includes('image')
                    ? 'image' : this.mimeType
    }
    return mimeType
}

export { countCreditsByPages, getFileMediaType }